const conversationSettings = {
  artificialDelay: 1000,
  states: {
    disabled: "is-disabled",
    loaded: "is-loaded",
    loading: "is-loading",
    selected: "is-selected",
    visible: "is-visible",
  },
};

const conversation = () => {
  initializeEventListeners();
};

const initializeEventListeners = (): void => {
  document.querySelectorAll(".js-conversation-option").forEach((option) => {
    option.addEventListener("click", handleOptionClick.bind(this));
  });

  document.querySelectorAll(".js-conversation-back").forEach((backButton) => {
    backButton.addEventListener("click", handleBackClick.bind(this));
  });

  document
    .querySelectorAll(".js-conversation-restart")
    .forEach((restartButton) => {
      restartButton.addEventListener("click", handleRestartClick.bind(this));
    });
};

const handleOptionClick = (event: Event): void => {
  const $target = event.currentTarget;
  if (!($target instanceof HTMLElement)) {
    return;
  }

  const $parent = $target.parentElement;

  if (
    $parent &&
    $parent.classList.contains(conversationSettings.states.disabled)
  ) {
    return;
  }

  const $currentNode = $target.closest(".js-conversation");
  if (!$currentNode) {
    return;
  }

  const currentNodeId = $currentNode.getAttribute("data-id");
  const targetId = $target.getAttribute("data-target");
  const $node = document.querySelector<HTMLElement>(
    `.js-conversation[data-id="${targetId}"]`,
  );

  if (!$node) {
    return;
  }

  $node.classList.add(
    conversationSettings.states.visible,
    conversationSettings.states.loading,
  );

  $currentNode.after($node);

  if ($parent) {
    $parent.classList.add(conversationSettings.states.disabled);
  }
  $target.classList.add(conversationSettings.states.selected);

  document.querySelectorAll(".js-conversation-back").forEach((backButton) => {
    backButton.setAttribute("data-target", targetId || "");
    backButton.setAttribute("data-previous", currentNodeId || "");
    backButton.setAttribute("href", "#node" + currentNodeId);
    backButton.classList.remove(conversationSettings.states.disabled);
  });

  // Artificially add a delay to the response
  setTimeout(() => {
    $node.classList.add(conversationSettings.states.loaded);
  }, conversationSettings.artificialDelay);
};

const handleBackClick = (event: Event): void => {
  const $target = event.currentTarget;
  if (!($target instanceof HTMLElement)) {
    return;
  }

  const targetNodeId = $target.getAttribute("data-target");
  const previousNodeId = $target.getAttribute("data-previous");

  if (!targetNodeId) {
    return;
  }

  const $node = document.querySelector<HTMLElement>(
    `.js-conversation[data-id="${targetNodeId}"]`,
  );

  if (previousNodeId) {
    const previousNode = document.querySelector<HTMLElement>(
      `.js-conversation[data-id="${previousNodeId}"]`,
    );
    if (previousNode) {
      previousNode
        .querySelectorAll(".js-conversation-options")
        .forEach((options) => {
          options.classList.remove(conversationSettings.states.disabled);
        });
      previousNode
        .querySelectorAll(".js-conversation-option")
        .forEach((option) => {
          option.classList.remove(conversationSettings.states.selected);
        });
    }
  }

  $node.classList.remove(
    conversationSettings.states.visible,
    conversationSettings.states.loading,
    conversationSettings.states.loaded,
  );
  $node.querySelectorAll(".js-conversation-options").forEach((options) => {
    options.classList.remove(conversationSettings.states.disabled);
  });
  $node.querySelectorAll(".js-conversation-option").forEach((option) => {
    option.classList.remove(conversationSettings.states.selected);
  });

  $target.classList.add(conversationSettings.states.disabled);
};

const handleRestartClick = (): void => {
  document.querySelectorAll(".js-conversation").forEach((conversation) => {
    if (!conversation.classList.contains("js-conversation-first")) {
      conversation.classList.remove(
        conversationSettings.states.visible,
        conversationSettings.states.loading,
        conversationSettings.states.loaded,
      );
    }
  });
  document.querySelectorAll(".js-conversation-options").forEach((options) => {
    options.classList.remove(conversationSettings.states.disabled);
  });
  document.querySelectorAll(".js-conversation-option").forEach((option) => {
    option.classList.remove(conversationSettings.states.selected);
  });
  document.querySelectorAll(".js-conversation-back").forEach((backButton) => {
    backButton.classList.add(conversationSettings.states.disabled);
  });
  scrollToTop();
};

const scrollToTop = () => {
  let $element = document.querySelector(".js-conversation-pane");
  if ($element) {
    setTimeout(() => {
      $element.scrollIntoView({ behavior: "smooth", block: "start" });
    }, conversationSettings.artificialDelay);
  }
};

export default conversation;
